// Filtro multi-select por estado con chips coloreados.
// `options`: [{ value, label, bg, color }] — usar el mismo color que el badge
// del estado. `selected`: array de values activos. Sin items seleccionados =
// no filtra (muestra todo).
export default function EstadoChipsFilter({ options, selected, onToggle, style = {} }) {
  return (
    <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap', margin: '0.4rem 0', ...style }}>
      {options.map(o => {
        const active = selected.includes(o.value)
        return (
          <button
            key={o.value}
            onClick={() => onToggle(o.value)}
            style={{
              padding: '5px 12px',
              borderRadius: 999,
              fontSize: '0.78rem',
              fontWeight: 600,
              cursor: 'pointer',
              border: active ? `1px solid ${o.color}` : '1px solid #e2e8f0',
              background: active ? o.bg : '#f8fafc',
              color: active ? o.color : '#475569',
              outline: 'none',
              transition: 'all 0.1s',
            }}
            title={active ? 'Click para sacar del filtro' : 'Click para filtrar por este estado'}
          >
            {o.label}
          </button>
        )
      })}
    </div>
  )
}
